import React from 'react';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const ShowIcon = () => (
  <Icon tooltip="Show" iconObj={faAngleDown} />
);

export default ShowIcon;